import { createContext } from 'react';
export const JsFormConfigContext = createContext({});
//# sourceMappingURL=JsFormConfigContext.js.map